module.exports = __webpack_public_path__ + "assets/img/modplug_tracker_title.613fea67.png";